var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { FloatingBox } from '@lucidlink/uicore';
import { MenuTrigger } from './MenuTrigger';
export const WorkspaceMenuShell = ({ menuContents, setIsMenuOpen, triggerTestId, workspaceId, }) => (_jsx(FloatingBox, { Content: menuContents, "data-testid": "workspace-item", placement: "bottom-start", stopEventPropagation: true, ...(setIsMenuOpen && { trackFloatingBoxState: setIsMenuOpen }), renderTrigger: (triggerProps) => (_jsx(MenuTrigger, { ...triggerProps, testId: `${workspaceId}-${triggerTestId}` })) }));
_react_refresh_temp_1 = WorkspaceMenuShell;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceMenuShell");
